import React, { useState } from 'react';
import TableCrud from '../../components/TableCrud';

import { Spreadsheet, createEmptyMatrix } from 'react-spreadsheet';
import { useEffect } from 'react';
import { FaNetworkWired } from 'react-icons/fa';
import Api, { exceptionNotificationAPI } from '../../services/api';
import { useParams } from 'react-router-dom';
import Select from 'react-select';
import { Container, ContainerHeader } from './styles';
import Button from '../../components/Button';
import { success_message, info_message, error_message } from '../../components/Toast/index';
import TableLoading from '../../components/TableLoading';
import { NumericFormat } from 'react-number-format';
import { useAuth } from '../../hooks/auth';
import Swal from 'sweetalert2';
import { FaTrashAlt } from 'react-icons/fa';
import optionsLogo from '../../assets/icons/options.svg';
import { formSelectStyles, formSelectControlFullWidth } from '../../components/FormInput/formSelectStyles';


const AdditionalDataFormIndex = () => {
    //Crop Year Select Variables
    const { userRoles } = useAuth();
    const [reportYears, setReportYears] = useState([]);
    const [volumeTypes, setVolumeTypes] = useState([]);
    const [tobaccoTypes, setTobaccoTypes] = useState([]);
    const [version, setVersion] = useState(null);
    const [isEditable, setIsEditable] = useState(null);
    const [showButtons, setShowButtons] = useState(null);
    const [selectedReportYearID, setSelectedReportYearID] = useState(null);
    const [selectedVolumeTypeID, setSelectedVolumeTypeID] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [rowLabels, setRowLabels] = useState([]);
    const [dataSheet, setDataSheet] = useState([
        [],
        [],
    ]);
    const [columns, setColumns] = useState(["ID", "Supplier", "Volume - FCV", "Volume - BY", "Volume - DFC", "Volume - Others", "Volume - Total", " "]);
    const [useDynamicColumns, setUseDynamicColumns] = useState(false);


    const removeRow = (id) => {
        Swal.fire({
            title: 'Are you sure you want delete the register?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'No',
            confirmButtonColor: '#102A63',
            cancelButtonColor: '#B0B0BB',
            confirmButtonText: 'Yes'
        }).then((result) => {
        if (result.isConfirmed) {
            Api.post(`AdditionalData/delete?id=${id}`).then((result) => {
                if (selectedReportYearID && selectedVolumeTypeID) {
                    loadDataByReportYear(selectedReportYearID, selectedVolumeTypeID)
                }
            })
        }
        })
     }

     const deleteAll = () => {
        Swal.fire({
            title: 'Are you sure, you want delete all?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'No',
            confirmButtonColor: '#102A63',
            cancelButtonColor: '#B0B0BB',
            confirmButtonText: 'Yes'
        }).then((result) => {
        if (result.isConfirmed) {
            Api.post(`AdditionalData/deleteAll?reportYearID=${selectedReportYearID}&volumeTypeID=${selectedVolumeTypeID}`).then((result) => {                
                if(result.data.response == true) {
                    if (selectedReportYearID && selectedVolumeTypeID) {
                        success_message("All values was deleted successfully!")
                        setTimeout(() => {
                            loadDataByReportYear(selectedReportYearID, selectedVolumeTypeID)
                        },2000)
                        
                    }
                }
                else {
                    error_message("Some error was happened. Please try again or contact the administrator.")
                }
            })
        }
        })
     }


    const InputNumberEdit = ({ cell, onChange }) => {
        var rowID = cell.className.split("-");
        return (
            <div style={{ padding: '0.5rem 1rem', textAlign:"center"}}  onClick={() => removeRow(rowID[1])}>
                <FaTrashAlt />
            </div>
        );
    };

    const InputOptions = ({ cell, onChange }) => {
        return (
            <div style={{ padding: '0.5rem 1rem'}}>
                <img src={optionsLogo} alt="" />
            </div>
        );
    };

    // Function to recalculate total for a specific row
    const recalculateRowTotal = React.useCallback((rowIndex) => {
        setDataSheet(prevData => {
            const newData = prevData.map((row, idx) => {
                if (idx !== rowIndex) return row;
                
                const newRow = [...row];
                
                if (useDynamicColumns) {
                    const totalColumnIndex = 2 + tobaccoTypes.length;
                    let total = 0;
                    
                    // Calculate total from all volume columns
                    for (let i = 2; i < totalColumnIndex; i++) {
                        const volumeValue = newRow[i] && newRow[i].value != "" 
                            ? parseFloat(newRow[i].value.toString().replaceAll(',', '')) 
                            : 0;
                        if (!isNaN(volumeValue)) {
                            total += volumeValue;
                        }
                    }
                    
                    // Update total column
                    if (newRow[totalColumnIndex]) {
                        newRow[totalColumnIndex] = { 
                            ...newRow[totalColumnIndex], 
                            value: total.toLocaleString('en') 
                        };
                    }
                } else {
                    // Legacy: 4 fixed columns
                    var col1 = newRow[2]?.value != "" ? parseFloat(newRow[2].value.replaceAll(',', '')) + "" : "0";
                    var col2 = newRow[3]?.value != "" ? parseFloat(newRow[3].value.replaceAll(',', '')) + "" : "0";
                    var col3 = newRow[4]?.value != "" ? parseFloat(newRow[4].value.replaceAll(',', '')) + "" : "0";
                    var col4 = newRow[5]?.value != "" ? parseFloat(newRow[5].value.replaceAll(',', '')) + "" : "0";

                    var expression = col1 + "+" + col2 + "+" + col3 + "+" + col4;
                    var totalValue = !isNaN(expression) ? "0" : eval(expression).toLocaleString('en');
                    
                    if (newRow[6]) {
                        newRow[6] = { ...newRow[6], value: totalValue };
                    }
                }
                
                return newRow;
            });
            
            return newData;
        });
    }, [useDynamicColumns, tobaccoTypes]);

    // Custom editor for volume cells with NumericFormat
    const VolumeNumberEditor = ({ cell, onChange, rowIndex }) => {
        const [value, setValue] = React.useState(cell?.value || '');
        
        React.useEffect(() => {
            setValue(cell?.value || '');
        }, [cell?.value]);

        const handleValueChange = (values) => {
            const newValue = values.value || '';
            setValue(newValue);
            if (onChange) {
                // Preserve style (including backgroundColor) when value changes
                onChange({ ...cell, value: newValue });
            }
            
            // Recalculate total for this row after a short delay to ensure dataSheet is updated
            if (rowIndex !== undefined) {
                setTimeout(() => {
                    recalculateRowTotal(rowIndex);
                }, 100);
            }
        };

        const backgroundColor = cell?.style?.backgroundColor || '#FFFFFF';

        return (
            <NumericFormat
                value={value}
                thousandSeparator={true}
                decimalScale={2}
                allowNegative={false}
                allowLeadingZeros={false}
                onValueChange={handleValueChange}
                style={{ 
                    width: '100%', 
                    padding: '0.5rem 1rem',
                    border: 'none',
                    outline: 'none',
                    textAlign: 'right',
                    backgroundColor: backgroundColor
                }}
                autoFocus
            />
        );
    };

    // Custom viewer for volume cells with NumericFormat
    const VolumeNumberViewer = ({ cell }) => {
        const value = cell?.value || '';
        const numValue = parseFloat(value.toString().replaceAll(',', '')) || 0;
        const backgroundColor = cell?.style?.backgroundColor || '#FFFFFF';
        
        return (
            <div style={{ 
                padding: '0.5rem 1rem',
                textAlign: 'right',
                width: '100%',
                backgroundColor: backgroundColor
            }}>
                {numValue.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </div>
        );
    };


    useEffect(() => {
        var userObjectAux = JSON.parse(localStorage.getItem('@Thrive:user'));
        loadReportYears(userObjectAux);
        loadAllVolumesTypes()
        // Don't load tobacco types here - will be loaded when version data is available
    }, [])


    useEffect(() => {
        if (selectedReportYearID && selectedVolumeTypeID) {
            loadDataByReportYear(selectedReportYearID, selectedVolumeTypeID);
        }
    }, [selectedReportYearID, selectedVolumeTypeID])

    const loadReportYears = (userAux) => {
        setIsLoading(true)
        Api.get(`thriveValue/getAllCropsYears?selectedCulture=${userAux.selectedCultureID}`).then((result) => {
            if (result && result.data) {
                setReportYears(result.data.response);
                setSelectedReportYearID(result.data.response[0].reportYearID);
                setIsLoading(false)
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    const loadAllVolumesTypes = (userAux) => {
        setIsLoading(true)
        Api.get(`VolumeType/getAll`).then((result) => {
            if (result && result.data) {
                setVolumeTypes(result.data.response);
                setSelectedVolumeTypeID(result.data.response[0].volumeTypeID);
                setIsLoading(false)

            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    /** Resolves tobacco types before building dynamic columns (avoids stale state from setTobaccoTypes). */
    const resolveTobaccoTypesForVersion = async (versionData = null) => {
        const snapshot = versionData?.approvedTobaccoTypesSnapshot || versionData?.ApprovedTobaccoTypesSnapshot;

        if (versionData && snapshot && String(snapshot).trim() !== '') {
            try {
                const snapshotTypes = JSON.parse(snapshot);
                return snapshotTypes.map((st) => ({
                    tobaccoTypeID: st.TobaccoTypeID,
                    name: st.Name,
                    isDeleted: false,
                    created: new Date(),
                    createdBy: '',
                    updated: null,
                    updatedBy: null
                }));
            } catch (error) {
                console.error('Error parsing ApprovedTobaccoTypesSnapshot:', error);
                console.error('Snapshot string that failed:', snapshot);
            }
        }

        const result = await Api.get(`TobaccoType/getAll`);
        if (result && result.data) {
            return result.data.response;
        }
        return [];
    };

    const onChangeCropID = (value) => {
        setSelectedReportYearID(value);
    }

    const onChangeVolumeID = (value) => {
        setSelectedVolumeTypeID(value);
    }

    const handleApprove = async (event) => {
        event.preventDefault();

        Swal.fire({
            title: 'Are you sure you want to approve this version?',
            showCancelButton: true,
            cancelButtonColor: '#B0B0BB',
            confirmButtonText: 'Yes',
            confirmButtonColor: '#112A61',
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading()
        }).then(async (result) => {
            if (result.isConfirmed) {
                setIsLoading(true);

                const objToRequest = {
                    "reportYearID": selectedReportYearID,
                    "volumeTypeID": selectedVolumeTypeID
                }

                await Api.post(`AdditionalData/approve`, objToRequest).then((result) => {
                    success_message("The data was approved successfully!");
                    setIsLoading(false);
                    loadDataByReportYear(selectedReportYearID, selectedVolumeTypeID);

                }).catch((error) => {
                    exceptionNotificationAPI(error);
                    setIsLoading(false);

                });
            }
        })
    }

    const handleSend = async (event) => {
        event.preventDefault();

        Swal.fire({
            title: 'Are you sure you want to submit this version?',
            text: "The version will be sent for approval.",
            icon: 'warning',
            showDenyButton: true,
            confirmButtonColor: '#112A61',
            denyButtonColor: '#B0B0BB',
            denyButtonText: 'No',
            confirmButtonText: 'Yes',
            showCloseButton: true
        }).then(async (result) => {
            if (result.isConfirmed) {
                var objAdditionalData = {
                    reportYearID: selectedReportYearID,
                    data: dataSheet,
                    volumeTypeID: selectedVolumeTypeID
                }
                setIsLoading(true);
                console.log(objAdditionalData)

                Api.post(`AdditionalData/send`, objAdditionalData).then((result) => {
                    success_message("The version was sent successfully!");
                    setIsLoading(false);
                    loadDataByReportYear(selectedReportYearID, selectedVolumeTypeID);

                }).catch((error) => {
                    exceptionNotificationAPI(error);
                    setIsLoading(false);
                });

            }

        })

    }

    const handleReactive = async (event) => {
        event.preventDefault();

        Swal.fire({
            title: 'Are you sure you want to reactive this version?',
            showCancelButton: true,
            cancelButtonColor: '#B0B0BB',
            confirmButtonText: 'Yes',
            confirmButtonColor: '#112A61',
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading()
        }).then(async (result) => {
            if (result.isConfirmed) {
                setIsLoading(true);

                const objToRequest = {
                    "reportYearID": selectedReportYearID,
                    "volumeTypeID": selectedVolumeTypeID
                }

                await Api.post(`AdditionalData/reactive`, objToRequest).then((result) => {
                    success_message("The data was reactivated successfully!");
                    setIsLoading(false);
                    loadDataByReportYear(selectedReportYearID, selectedVolumeTypeID);

                }).catch((error) => {
                    exceptionNotificationAPI(error);
                    setIsLoading(false);

                });
            }
        })

    }

    const handleReject = async (event) => {
        event.preventDefault();

        Swal.fire({
            title: 'Are you sure you want to reject this version?',
            showCancelButton: true,
            cancelButtonColor: '#B0B0BB',
            confirmButtonText: 'Yes',
            confirmButtonColor: '#112A61',
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading()
        }).then(async (result) => {
            if (result.isConfirmed) {
                setIsLoading(true);

                const objToRequest = {
                    "reportYearID": selectedReportYearID,
                    "volumeTypeID": selectedVolumeTypeID
                }

                await Api.post(`AdditionalData/reject`, objToRequest).then((result) => {
                    success_message("The data was rejected successfully!");
                    setIsLoading(false);
                    loadDataByReportYear(selectedReportYearID, selectedVolumeTypeID);

                }).catch((error) => {
                    exceptionNotificationAPI(error);
                    setIsLoading(false);

                });
            }
        })

    }

    const loadDataByReportYear = async (selectedReportYear, selectedVolumeTypeID) => {
        if (!selectedReportYear) return;
        setIsLoading(true);
        try {
            const result = await Api.get(`AdditionalData/getAllByCrop?reportYearID=${selectedReportYear}&volumeTypeID=${selectedVolumeTypeID}`);
            if (!result || !result.data) return;

            console.log(result.data.response);
            const versionData = result.data.response.version;
            setVersion(versionData);

            var isDataEditable = false;
            var resultList = result.data.response.data;

            const selectedYearObj = reportYears.find((y) => y.reportYearID == selectedReportYear);
            const year = selectedYearObj ? parseInt(selectedYearObj.year) : 0;
            const useDynamic = year >= 2025;
            setUseDynamicColumns(useDynamic);

            let resolvedTobaccoTypes = [];
            if (useDynamic) {
                resolvedTobaccoTypes = await resolveTobaccoTypesForVersion(versionData);
                setTobaccoTypes(resolvedTobaccoTypes);
            } else {
                setTobaccoTypes([]);
            }

            if (useDynamic) {
                const dynamicColumns = ["ID", "Supplier"];
                resolvedTobaccoTypes.forEach((tobaccoType) => {
                    dynamicColumns.push(`${tobaccoType.name}`);
                });
                dynamicColumns.push("Volume - Total", " ");
                setColumns(dynamicColumns);
            } else {
                setColumns(["ID", "Supplier", "Volume - FCV", "Volume - BY", "Volume - DFC", "Volume - Others", "Volume - Total", " "]);
            }

            var newLine = [];
            if (useDynamic) {
                newLine = [{ value: "", readOnly: true, active: false }, { value: "" }];
                resolvedTobaccoTypes.forEach(() => {
                    newLine.push({ value: "" });
                });
                newLine.push({ value: "" });
                newLine.push({ value: " " });
            } else {
                newLine = [
                    { value: "", readOnly: true, active: false },
                    { value: "" },
                    { value: "" },
                    { value: "" },
                    { value: "" },
                    { value: "" },
                    { value: "" },
                    { value: "" },
                    { value: " " },
                ];
            }
            resultList.push(newLine);

            if (userRoles.includes("RoleAdmin")) {
                if (result.data.response.version != null) {
                    if (result.data.response.version.status == 4) {
                        setIsEditable(false);
                        setShowButtons(true);
                    } else {
                        setIsEditable(false);
                        setShowButtons(false);
                    }
                } else {
                    setIsEditable(false);
                    setShowButtons(false);
                }
            } else if (userRoles.includes("RoleVolumeDataInfoHolder")) {
                if (result.data.response.version != null) {
                    if (result.data.response.version.status == 1 || result.data.response.version.status == 3 || result.data.response.version.status == 5) {
                        setIsEditable(true);
                        setShowButtons(true);
                        isDataEditable = true;
                    } else if (result.data.response.version.status == 2 || result.data.response.version.status == 4) {
                        setIsEditable(false);
                        setShowButtons(false);
                    }
                } else {
                    setIsEditable(true);
                    setShowButtons(true);
                    isDataEditable = true;
                }
            } else if (userRoles.includes("RoleVolumeDataApprover")) {
                if (result.data.response.version != null) {
                    if (result.data.response.version.status == 2) {
                        setIsEditable(false);
                        setShowButtons(true);
                    } else {
                        setIsEditable(false);
                        setShowButtons(false);
                    }
                } else {
                    setIsEditable(false);
                    setShowButtons(false);
                }
            }

            try {
                resultList.map((row) => {
                    var newRow = row.map((col) => {
                        var newCol = { ...col };
                        return newCol;
                    });
                    return newRow;
                });

                try {
                    resultList.map((row, rowIdx) => {
                        row[0] = { value: row[0].value, readOnly: true, active: false };

                        if (useDynamic) {
                            const totalColumnIndex = 2 + resolvedTobaccoTypes.length;
                            const actionsColumnIndex = totalColumnIndex + 1;
                                    
                                    // Ensure row has enough elements
                                    while (row.length < actionsColumnIndex) {
                                        row.push({ value: "" });
                                    }
                                    
                                    // Apply NumericFormat to all volume columns (index 2 to totalColumnIndex-1)
                                    for (let i = 2; i < totalColumnIndex; i++) {
                                        if (!row[i]) row[i] = { value: "" };
                                        
                                        // Preserve color from backend and apply as backgroundColor
                                        const backgroundColor = row[i].color || '#FFFFFF';
                                        row[i] = {
                                            ...row[i],
                                            style: {
                                                backgroundColor: backgroundColor
                                            }
                                        };
                                        
                                        // Create a wrapper that passes rowIndex to VolumeNumberEditor
                                        row[i].DataEditor = (props) => <VolumeNumberEditor {...props} rowIndex={rowIdx} />;
                                        row[i].DataViewer = VolumeNumberViewer;
                                    }
                                    
                                    // Calculate total from all tobacco type volumes
                                    let total = 0;
                                    for (let i = 2; i < totalColumnIndex; i++) {
                                        const volumeValue = row[i] && row[i].value != "" ? parseFloat(row[i].value.toString().replaceAll(',', '')) : 0;
                                        if (!isNaN(volumeValue)) {
                                            total += volumeValue;
                                        }
                                    }
                                    row[totalColumnIndex] = { value: total.toLocaleString('en'), readOnly: true }; // Total column
                                    
                                    // Set Actions column
                                    row[actionsColumnIndex] = { value: " ", readOnly: false, className: 'remove-' +row[0].value, onClick: () => removeRow(row[0].value)};
                                    row[actionsColumnIndex].DataViewer = InputOptions;
                                    row[actionsColumnIndex].DataEditor = InputNumberEdit;
                                } else {
                                    // Legacy: 4 fixed columns - apply NumericFormat
                                    // Backend returns: [ID, Supplier, FCV, BY, DFC, Others]
                                    // We need to add: Total (index 6) and Actions (index 7)
                                    while (row.length < 8) {
                                        row.push({ value: "" });
                                    }
                                    
                                    for (let i = 2; i <= 5; i++) {
                                        if (!row[i]) row[i] = { value: "" };
                                        // Create a wrapper that passes rowIndex to VolumeNumberEditor
                                        row[i].DataEditor = (props) => <VolumeNumberEditor {...props} rowIndex={rowIdx} />;
                                        row[i].DataViewer = VolumeNumberViewer;
                                    }
                                    
                                    // Calculate total
                                    var col1 = row[2].value != "" ? parseFloat(row[2].value.replaceAll(',', '')) + "" : "0";
                                    var col2 = row[3].value != "" ? parseFloat(row[3].value.replaceAll(',', '')) + "" : "0";
                                    var col3 = row[4].value != "" ? parseFloat(row[4].value.replaceAll(',', '')) + "" : "0";
                                    var col4 = row[5].value != "" ? parseFloat(row[5].value.replaceAll(',', '')) + "" : "0";

                                    var expression = col1 + "+" + col2 + "+" + col3 + "+" + col4;
                                    console.log(expression);

                                    row[6] = { value: !isNaN(expression) ? "0" : eval(expression).toLocaleString('en'), readOnly: true };
                                    
                                    // Set Actions column
                                    row[7] = { value: " ", readOnly: false, className: 'remove-' +row[0].value, onClick: () => removeRow(row[0].value)};
                                    row[7].DataViewer = InputOptions;
                                    row[7].DataEditor = InputNumberEdit;
                                }

                                if (!isDataEditable) {
                                    row.map((item) => {
                                        item.readOnly = true;
                                    })
                                }
                            })

                        } catch { }
                        setDataSheet(resultList);
                    } catch (e) {
                        console.log(e);
                    }
        } catch (error) {
            exceptionNotificationAPI(error);
        } finally {
            setIsLoading(false);
        }
    };

    const save = () => {
        var objAdditionalData = {
            reportYearID: selectedReportYearID,
            data: dataSheet,
            volumeTypeID: selectedVolumeTypeID
        }
        setIsLoading(true);
        console.log(objAdditionalData)

        Api.post(`AdditionalData/New`, objAdditionalData).then((result) => {
            if (result && result.data) {
                setIsLoading(false);
                if (result.data.response == true) {
                    success_message("The data was saved!");
                    loadDataByReportYear(selectedReportYearID, selectedVolumeTypeID)
                }
                else {
                    info_message("No data to saved!");
                }
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    const onChangeTable = (e) => {
        try {
            // Recalculate totals for all rows before setting the data
            const updatedData = e.map((row, rowIdx) => {
                const newRow = [...row];
                
                // Preserve the original ID value from dataSheet to prevent copy/paste or editing
                // ID column (index 0) should always be readOnly and cannot be changed
                // The ID is only populated after saving to the database
                const originalRow = dataSheet[rowIdx];
                if (originalRow && originalRow[0] && originalRow[0].value) {
                    // Restore original ID value and ensure it's readOnly (for existing saved rows)
                    newRow[0] = { 
                        value: originalRow[0].value, 
                        readOnly: true, 
                        active: false 
                    };
                } else {
                    // For new rows or rows without ID, always keep ID empty and readOnly
                    // This prevents any copy/paste or manual editing of the ID column
                    newRow[0] = { 
                        value: "", 
                        readOnly: true, 
                        active: false 
                    };
                }
                
                if (useDynamicColumns) {
                    const totalColumnIndex = 2 + tobaccoTypes.length;
                    let total = 0;
                    
                    // Calculate total from all volume columns and preserve backgroundColor
                    for (let i = 2; i < totalColumnIndex; i++) {
                        // Preserve backgroundColor from original row or from the cell itself
                        const originalCell = originalRow && originalRow[i];
                        const existingBackgroundColor = newRow[i]?.style?.backgroundColor || 
                                                       originalCell?.style?.backgroundColor || 
                                                       originalCell?.color || 
                                                       '#FFFFFF';
                        
                        // Preserve style when updating cell
                        if (newRow[i]) {
                            newRow[i] = {
                                ...newRow[i],
                                style: {
                                    backgroundColor: existingBackgroundColor
                                }
                            };
                        }
                        
                        const volumeValue = newRow[i] && newRow[i].value != "" 
                            ? parseFloat(newRow[i].value.toString().replaceAll(',', '')) 
                            : 0;
                        if (!isNaN(volumeValue)) {
                            total += volumeValue;
                        }
                    }
                    
                    // Update total column
                    if (newRow[totalColumnIndex]) {
                        newRow[totalColumnIndex] = { 
                            ...newRow[totalColumnIndex], 
                            value: total.toLocaleString('en') 
                        };
                    }
                } else {
                    // Legacy: 4 fixed columns
                    var col1 = newRow[2]?.value != "" ? parseFloat(newRow[2].value.replaceAll(',', '')) + "" : "0";
                    var col2 = newRow[3]?.value != "" ? parseFloat(newRow[3].value.replaceAll(',', '')) + "" : "0";
                    var col3 = newRow[4]?.value != "" ? parseFloat(newRow[4].value.replaceAll(',', '')) + "" : "0";
                    var col4 = newRow[5]?.value != "" ? parseFloat(newRow[5].value.replaceAll(',', '')) + "" : "0";

                    var expression = col1 + "+" + col2 + "+" + col3 + "+" + col4;
                    var totalValue = !isNaN(expression) ? "0" : eval(expression).toLocaleString('en');
                    
                    if (newRow[6]) {
                        newRow[6] = { ...newRow[6], value: totalValue };
                    }
                }
                
                return newRow;
            });
            
            setDataSheet(updatedData);
        } catch { }
    }


    const onBlurTable = () => {
        try {
            var nesw = dataSheet.map((row) => {
                var newRow = row.map((col) => {
                    var newCol = { ...col };
                    return newCol;
                })
                return newRow;
            })

            try {
                nesw.map((row, rowIdx) => {
                    row[0] = { value: row[0].value, readOnly: true, active: false}
                    
                    // Apply NumericFormat to volume columns
                    if (useDynamicColumns) {
                        // Dynamic columns: calculate correct indices
                        const totalColumnIndex = 2 + tobaccoTypes.length;
                        const actionsColumnIndex = totalColumnIndex + 1;
                        
                        // Ensure row has enough elements
                        while (row.length < actionsColumnIndex) {
                            row.push({ value: "" });
                        }
                        
                        // Apply NumericFormat to all volume columns
                        for (let i = 2; i < totalColumnIndex; i++) {
                            if (!row[i]) row[i] = { value: "" };
                            
                            // Preserve backgroundColor from existing cell or default to white
                            const existingBackgroundColor = row[i].style?.backgroundColor || row[i].color || '#FFFFFF';
                            row[i] = {
                                ...row[i],
                                style: {
                                    backgroundColor: existingBackgroundColor
                                }
                            };
                            
                            // Create a wrapper that passes rowIndex to VolumeNumberEditor
                            row[i].DataEditor = (props) => <VolumeNumberEditor {...props} rowIndex={rowIdx} />;
                            row[i].DataViewer = VolumeNumberViewer;
                        }
                        
                        // Calculate total from all tobacco type volumes
                        let total = 0;
                        for (let i = 2; i < totalColumnIndex; i++) {
                            const volumeValue = row[i] && row[i].value != "" ? parseFloat(row[i].value.toString().replaceAll(',', '')) : 0;
                            if (!isNaN(volumeValue)) {
                                total += volumeValue;
                            }
                        }
                        row[totalColumnIndex] = { value: total.toLocaleString('en'), readOnly: true }; // Total column
                        
                        // Set Actions column
                        row[actionsColumnIndex] = { value: " ", readOnly: false, className: 'remove-' +row[0].value, onClick: () => removeRow(row[0].value)};
                        row[actionsColumnIndex].DataViewer = InputOptions;
                        row[actionsColumnIndex].DataEditor = InputNumberEdit;
                    } else {
                        // Legacy: 4 fixed columns - apply NumericFormat
                        while (row.length < 8) {
                            row.push({ value: "" });
                        }
                        
                        for (let i = 2; i <= 5; i++) {
                            if (!row[i]) row[i] = { value: "" };
                            // Create a wrapper that passes rowIndex to VolumeNumberEditor
                            row[i].DataEditor = (props) => <VolumeNumberEditor {...props} rowIndex={rowIdx} />;
                            row[i].DataViewer = VolumeNumberViewer;
                        }
                        
                        // Calculate total
                        var col1 = row[2].value != "" ? parseFloat(row[2].value.replaceAll(',', '')) + "" : "0";
                        var col2 = row[3].value != "" ? parseFloat(row[3].value.replaceAll(',', '')) + "" : "0";
                        var col3 = row[4].value != "" ? parseFloat(row[4].value.replaceAll(',', '')) + "" : "0";
                        var col4 = row[5].value != "" ? parseFloat(row[5].value.replaceAll(',', '')) + "" : "0";

                        var expression = col1 + "+" + col2 + "+" + col3 + "+" + col4;
                        console.log(expression);

                        row[6] = { value: !isNaN(expression) ? "0" : eval(expression).toLocaleString('en'), readOnly: true };
                        
                        // Set Actions column
                        row[7] = { value: " ", readOnly: false, className: 'remove-' +row[0].value, onClick: () => removeRow(row[0].value)};
                        row[7].DataViewer = InputOptions;
                        row[7].DataEditor = InputNumberEdit;
                    }

                    if (!isEditable) {
                        row.map((item) => {
                            item.readOnly = true;
                        })
                    }
                })

            } catch { }
            setDataSheet(nesw);
        } catch (e) {
            console.log(e)
        }
    }



    return (
        <Container className="container">
            <div style={{ margin: '2rem' }}>
                <div className='row'>
                    <div className="col-7 d-flex header">
                        <h3>Additional Data - Volumes</h3>
                        {version != null && (version.status == 1 || version.status == 2 || version.status == 4) ?
                            <p className='status' style={{ backgroundColor: '#abf0b0' }}>{version != null ? version.statusName : ""}</p>
                            : version != null && (version.status == 3 || version.status == 5) ?
                                <p className='status' style={{ backgroundColor: '#fb9d9d' }}>{version != null ? version.statusName : ""}</p>
                                :
                                <p className='status' style={{ backgroundColor: '#e6e6e6' }}>{"Not Started"}</p>
                        }

                    </div>
                    {userRoles.includes("RoleVolumeDataApprover") && showButtons && !isEditable && //Approver
                        <div className='col-5 d-flex justify-content-end'>
                            <div className="reject-btn">
                                <button className="" type="button" onClick={(e) => handleReject(e)}>REJECT</button>
                            </div>
                            <div className="approve-btn">
                                <button className="" type="button" onClick={(e) => handleApprove(e)}>APPROVE</button>
                            </div>
                            
                        </div>
                    }
                    {userRoles.includes("RoleAdmin") && showButtons && !isEditable && //Admin
                        <div className='col-5'>
                            <div className="approve-btn">
                                <button className="approve-btn" type="button" onClick={(e) => handleReactive(e)}>REACTIVATE</button>
                            </div>
                        </div>
                    }
                    {userRoles.includes("RoleVolumeDataInfoHolder") && showButtons &&
                        <div className='col-5 d-flex justify-content-end'>
                            <div className="send-btn">
                                <button className='' onClick={(e) => handleSend(e)}>SEND</button>
                            </div>
                            <div className="save-btn">
                                <button className='' onClick={() => save()}>SAVE DRAFT</button>
                            </div>
                            {version != null && version.status == 1 &&
                            <div className="send-btn">
                                <button className="" type="button" onClick={(e) => deleteAll()}>DELETE ALL</button>
                            </div>
                            }
                        </div>
                    }
                </div>
            </div>
            <div className="row mt-2 mx-4">
                <div className="col-md-6 mt-2" style={{ width: '100%' }}>
                    <label className='label'>Select Reporting Year</label>
                    <div className="col-md-12 mt-2" style={{ width: '100%' }}>
                        <Select
                            options={reportYears?.map((y) => ({ value: y.reportYearID, label: y.year })) ?? []}
                            value={reportYears?.find((y) => y.reportYearID === selectedReportYearID) ? { value: selectedReportYearID, label: reportYears.find((y) => y.reportYearID === selectedReportYearID).year } : null}
                            onChange={(x) => onChangeCropID(x?.value ?? '')}
                            placeholder="Select Reporting Year"
                            isSearchable
                            isClearable={false}
                            styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                            classNamePrefix="additionaldata-reportyear"
                        />
                    </div>
                </div>
                <div className="col-md-6 mt-2" style={{ width: '100%' }}>
                    <label className='label'>Select Volume Type</label>
                    <div className="col-md-12 mt-2" style={{ width: '100%' }}>
                        <Select
                            options={volumeTypes?.map((v) => ({ value: v.volumeTypeID, label: v.name })) ?? []}
                            value={volumeTypes?.find((v) => v.volumeTypeID === selectedVolumeTypeID) ? { value: selectedVolumeTypeID, label: volumeTypes.find((v) => v.volumeTypeID === selectedVolumeTypeID).name } : null}
                            onChange={(x) => onChangeVolumeID(x?.value ?? '')}
                            placeholder="Select Volume Type"
                            isSearchable
                            isClearable={false}
                            styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                            classNamePrefix="additionaldata-volumetype"
                        />
                    </div>
                </div>
            </div>
            {!isLoading ?
                <div style={{ 
                    margin: '2rem', 
                    overflowX: 'auto', 
                    overflowY: 'auto',
                    maxWidth: '100%',
                    border: '1px solid #ddd'
                }}>
                    <Spreadsheet 
                        data={dataSheet} 
                        columnLabels={columns} 
                        rowLabels={rowLabels} 
                        onBlur={() => onBlurTable()} 
                        onChange={(e) => onChangeTable(e)} 
                    />
                </div>
                :
                <TableLoading />
            }

        </Container>

    )
}

export default AdditionalDataFormIndex;

